import { render, staticRenderFns } from "./devicesEdit.vue?vue&type=template&id=487a3710&scoped=true&"
import script from "./devicesEdit.vue?vue&type=script&lang=js&"
export * from "./devicesEdit.vue?vue&type=script&lang=js&"
import style0 from "./devicesEdit.vue?vue&type=style&index=0&id=487a3710&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a3710",
  null
  
)

component.options.__file = "devicesEdit.vue"
export default component.exports